"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateClassMapping = void 0;
exports.RateClassMapping = {
    "1": "ULTRA",
    "2": "SELECT",
    "3": "STANDARD",
    "4": "SELECT_TOBACCO",
    "5": "STANDARD_TOBACCO",
    "6": "BEST",
    "7": "BETTER",
    "8": "AVERAGE",
    "9": "TOBACCO",
    "10": "NT_PLUS",
    "60.101": "TABLE_A",
    "60.102": "TABLE_B",
    "60.103": "TABLE_C",
    "60.104": "TABLE_D",
    "60.105": "TABLE_E",
    "60.106": "TABLE_F",
    "60.107": "TABLE_G",
    "60.108": "TABLE_H",
    "60.109": "TABLE_I",
    "60.110": "TABLE_J",
    "60.111": "TABLE_K",
    "60.112": "TABLE_L",
    "60.113": "TABLE_M",
    "60.114": "TABLE_N",
    "60.115": "TABLE_O",
    "60.116": "TABLE_P",
    "70.101": "TABLE_A_TOBACCO",
    "70.102": "TABLE_B_TOBACCO",
    "70.103": "TABLE_C_TOBACCO",
    "70.104": "TABLE_D_TOBACCO",
    "70.105": "TABLE_E_TOBACCO",
    "70.106": "TABLE_F_TOBACCO",
    "70.107": "TABLE_G_TOBACCO",
    "70.108": "TABLE_H_TOBACCO",
    "70.109": "TABLE_I_TOBACCO",
    "70.110": "TABLE_J_TOBACCO",
    "70.111": "TABLE_K_TOBACCO",
    "70.112": "TABLE_L_TOBACCO",
    "70.113": "TABLE_M_TOBACCO",
    "70.114": "TABLE_N_TOBACCO",
    "70.115": "TABLE_O_TOBACCO",
    "70.116": "TABLE_P_TOBACCO",
};
